import { ImageModel } from '@shared/ui/Media/MediaImg/types/types'
import { TypeWidthHeight } from '@shared/ui/Media/MediaImg/MediaImg'

const RESIZER_NODES = [
  'img01.rl0.ru',
  'img02.rl0.ru',
  'img03.rl0.ru',
  'img04.rl0.ru',
  'img05.rl0.ru',
  'img06.rl0.ru',
  'img07.rl0.ru',
  'img08.rl0.ru',
  'img09.rl0.ru',
]

const RESIZER_RESOURCE = 'afisha'

type Data =
  | string
  | number
  | symbol
  | boolean
  | null
  | undefined
  | { [property: string]: Data }
  | Data[]
  | NonNullable<unknown>

export const Hash = (data: unknown): number => {
  if (data === undefined || data === null) {
    return 0
  }

  const result = JSON.stringify(data, (_key: string, value: Data) => {
    if (typeof value === 'object') {
      if (value === null || Array.isArray(value)) {
        return value
      } else {
        if (value.valueOf() !== value) {
          return value.valueOf()
        } else {
          return Object.entries(value).sort((a, b) => (a[0] > b[0] ? 1 : a[0] === b[0] ? 0 : -1))
        }
      }
    } else if (typeof value === 'string' || typeof value === 'bigint') {
      return _hash(value.toString())
    } else {
      return value
    }
  })

  return _hash(result)
}

export const _hash = (data: string) => {
  let hash = 0

  for (let i = 0, len = data.length; i < len; i++) {
    hash = (hash << 5) - hash + data[i].charCodeAt(0)
    hash |= 0
  }

  return hash < 0 ? hash * -2 : hash
}

const getNodeByUrl = (url: string) => {
  const indexNode = Math.abs(_hash(url) % RESIZER_NODES.length)
  return RESIZER_NODES[indexNode]
}

const getCropString = (crop: ImageModel['Crop'] | null | undefined) => {
  return crop ? `p${crop.X}x${crop.Y}f${crop.Width}x${crop.Height}` : ''
}

const getResizedLink = (
  image: Pick<ImageModel, 'Url' | 'Crop' | 'Width' | 'Height'>,
  size: TypeWidthHeight,
  multiplier: number,
  optionsString: string,
) => {
  const urlWithoutHttp = image.Url.replace(/^https?:\/\//, '')
  const node = getNodeByUrl(urlWithoutHttp)

  const urlBase = `https://${node}/${RESIZER_RESOURCE}`

  const width_ = size.width ? Math.floor(size.width * multiplier) : null
  const height_ = size.height ? Math.floor(size.height * multiplier) : null

  let cropString = ''
  if (image.Crop && size.height && size.width) {
    const cropWidthNew = (width_ * image.Crop.Height) / height_
    const cropXDelta = (image.Crop.Width - cropWidthNew) / 2

    const cropXNew = Math.max(image.Crop.X + cropXDelta, 0)

    cropString = getCropString({
      X: Math.floor(cropXNew),
      Y: image.Crop.Y,
      Width: Math.floor(cropWidthNew),
      Height: image.Crop.Height,
    })
  }

  const src = `${urlBase}/e${width_ || '-'}x${height_ || '-'}${cropString}${optionsString}/${urlWithoutHttp}`

  return src
}

type Options = {
  Quality?: number
  ProgressiveJpeg?: boolean
  Watermark?: {
    Number: number
    Position: number
  }
}
const getResizerOptionsString = (multiplier: number, _options?: Options) => `q${multiplier <= 1 ? 85 : 65}i`

export function GetResizedLinkWithCustomSize(
  image: ImageModel | string | null | undefined,
  size: TypeWidthHeight,
  multiplier = 1,
) {
  if (!image) {
    return null
  }

  // prettier-ignore
  const imageModel =
    typeof image === 'string'
      ? { Url: image, Crop: null, Width: size.width, Height: size.height }
      : image;

  const optionsString = getResizerOptionsString(multiplier)

  return getResizedLink(imageModel, size, multiplier, optionsString)
}

export const IsAfishaImage = (url: string) => url.includes('afisha.ru')
export const IsAlreadyResized = (url: string) => url.includes('rl0.ru')
